import BaseModel from '@/api/models/BaseModel';
import CryptoJS from 'crypto-js';

/**
 * Encrypter
 * This class is responsible by encrypting, decrypting and having some usefull methods 
 */
export default class Encrypter extends BaseModel {

    /**
     * Construct this Encrypter with sent parameters
     * @param {String} text
     */
    constructor(text = '') {
        super();
        this.text = text;
    }

    /**
     * Encrypt a string value
     * @param {String} text 
     * @returns {String}
     */
    encrypt(text = '') {
        let val = ![null, false, true, undefined].includes(text) && text.length > 0 ? text : this.text;
        try {
            const key = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_ENCRYPTION_KEY);
            const iv = CryptoJS.lib.WordArray.random(16); // 16 bytes for IV
            const encrypted = CryptoJS.AES.encrypt(val, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

            return iv.toString(CryptoJS.enc.Hex) + ':' + encrypted.ciphertext.toString(CryptoJS.enc.Hex);
        } catch (error) {
            console.error('Encryption error:', error);
            return '';
        }
    }

    /**
     * Decrypt a string value
     * @param {String} encryptedText 
     * @returns {String}
     */
    decrypt(encryptedText = '') {
        let val = ![null, false, true, undefined].includes(encryptedText) && encryptedText.length > 0 ? encryptedText : this.text;
        try {
            const [ivHex, encryptedHex] = val.split(':');
            if (!ivHex || !encryptedHex) {
                console.error('Invalid encrypted text format');
                return '';
            }
            const iv = CryptoJS.enc.Hex.parse(ivHex);
            const encrypted = CryptoJS.enc.Hex.parse(encryptedHex);
            const key = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_ENCRYPTION_KEY);
            const decrypted = CryptoJS.AES.decrypt(
                { ciphertext: encrypted },
                key,
                { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
            );

            const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
            if (decryptedText === '') {
                console.error('Decryption failed');
                return '';
            }
            return decryptedText;
        } catch (error) {
            console.error('Decryption error:', error);
            return '';
        }
    }

    /**
     * Checks if text is encrypted
     * @param {*} str 
     * @returns 
     */
    isEncrypted(text = '') {
        let val = ![null, false, true, undefined].includes(text) && text.length > 0 ? text : this.text;
        const encryptedPattern = /^[A-Fa-f0-9]+:[A-Fa-f0-9]+$/;
        return encryptedPattern.test(val);
    }
}
